/**
 * A chave carrega o usuário mesmo com a RLS já filtrando por destinatário:
 * sem ele, a troca de conta serviria as notificações da sessão anterior
 * direto do cache (docs/04 §2).
 */
export const notificationsKeys = {
  all: ['notifications'] as const,
  mine: (profileId: string) => [...notificationsKeys.all, 'mine', profileId] as const,
  /**
   * A contagem é chave própria, e não um `select` sobre a lista: quem a consome
   * é a barra inferior, presente em toda tela-destino, e ela não pode arrastar
   * a lista inteira de notificações só para desenhar um número.
   */
  unreadCount: (profileId: string) =>
    [...notificationsKeys.all, 'unread-count', profileId] as const,
} as const;
